<template>
  <div class="home">LOADING</div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  created() {
    this.$router.replace("/admin/book/list");
  },
};
</script>
